import React, { useEffect, useState } from "react";
import {
  InputBox,
  Select2,
  Tooltip,
} from "../../../components/Elements/appUtils";
import _ from "lodash";
import Select from "rc-select";
import { fetchCustomer } from "../actions";
import "../../../components/Elements/Select/index.css";
import "rc-select/assets/index.less";

const { Option } = Select;

const SearchCustomer = (props) => {
  let {
    callback,
    customerId,
    gstType,
    type,
    groupType,
  } = props;

  let [clientId, setClientId] = useState(undefined);
  let [billingState, setBillingState] = useState("");
  let [customerNames, setCustomerNames] = useState("");
  let [arrData, setArrData] = useState([]);
  let [visible, setVisible] = useState(false);
  const events = {
    loadDefaultClient: async () => {
      if (customerId) {
        let params = {
          results: 20,
          count: 20,
          _id: customerId,
          regExFilters: [
            "name",
            "companyName",
            "mobile",
            "state",
            "discount",
            "uhid",
          ],
          select: [
            "name",
            "companyName",
            "mobile",
            "state",
            "discount",
            "uhid",
          ],
        };
        let { data } = await fetchCustomer(params);
        const matchingClient = data.find(client => client._id === customerId );
        if (matchingClient && matchingClient.name){
          setCustomerNames(matchingClient.name)
        }
        setArrData(data);
      } else {
        setArrData([]);
        setClientId(undefined)
      }
    },

    fetchClientByNameOrMobile: async (value) => {
      const searchValue = String(value ?? '').trim();

      if (!searchValue) {
        return;
      }

      if (/^\d{10}$/.test(searchValue)) {
        // 10 digit number = mobile
        events.fetchClient(undefined, searchValue, undefined);
      } else if (/^\d{4,9}$/.test(searchValue)) {
        // 4-9 digit number = UHID
        events.fetchClient(undefined, undefined, searchValue);
      } else {
        // Name
        events.fetchClient(searchValue, undefined, undefined);
      }
    },
    
    fetchClient: async (name, mobile, uhid) => {
      try {
        let params = {
          results: 20,
          count: 20,
          type: type,
          gstType: gstType,
          groupType: groupType,
          regExFilters: ["name", "mobile", "email", "state", "uhid"],
          select: ["name", "mobile", "uhid", "state"],
        };

        if (name) {
          params.name = name;
        }

        if (mobile) {
          params.mobile = mobile;
        }

        if (uhid) {
          params.uhid = uhid;
        }

        if (name || mobile || uhid) {
          const { data } = await fetchCustomer(params);
          setArrData(data);
        } else {
          setArrData([]);
        }
      } catch (error) {
        console.error("Error fetching client data:", error);
      }
    },

    handleChange: (clientId) => {
      let item = _.find(arrData, (value) => {
        return value._id == clientId;
      });

      setClientId(clientId);
      callback(item);
    },
  };
  useEffect(() => {
    events.loadDefaultClient();
  }, [customerId]);

  let addCustomerCallback = (data) => {
    setVisible(false);
    if (data && data.name) {
      setArrData([data]);
      setClientId(data._id);
      setBillingState(data.state);
      callback(data);
    }
  };

  return (
    <>
        <div className={"rowFlex"}>
          <Select
            showSearch={true}
            onSearch={(value) => events.fetchClientByNameOrMobile(value)}
            filterOption={false}
            autoClearSearchValue={true}
            allowClear={true}
            value={clientId}
            showArrow={true}
            onChange={events.handleChange}
            placeholder="Search Name.."
            className={`rc-select rc-select1`}
            choiceTransitionName="rc-select-selection__choice-zoom"
            dropdownRender={(menu) => {
              return <div key={arrData}>{menu}</div>;
            }}
          >
            {arrData && arrData.length
              ? arrData.map((item, index) => {
                  return (
                    <Option key={item._id} value={item._id}>
                      {`${item.name} (${item.uhid ? `ID-${item.uhid}, ` : ""}${
                        item.mobile ? `${item.mobile}` : ""
                      })`}
                    </Option>
                  );
                })
              : null}
          </Select>
        </div>
    </>
  );
};
export default SearchCustomer;
